import React from "react";
import { useEffect, useRef, useState } from "react";
import styles from "../../Header.module.scss";
import PortraitTile from "../../../BuilderIO/PortraitTile/PortraitTile";
import { handleize, makeId } from "@/helpers/userHelpers";
import { navigationTracking } from "@/components/common/Tracking";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import { useSelector,useDispatch } from "react-redux";

export function SubMenuColumn({ columns, countOfPortraitTile, navigationTitle }) {
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const dispatch = useDispatch();

  const handleClick = (e,href) => {
    if(isPWA) {
      dispatch(showPwaLoader(true))
    }

    // to find the fixed header parent class
    const isFixedHeader = e.target.closest(".fixed-header");
    if(isFixedHeader && href) {
      // href is the link to the subpage
      window.location.href = href;
    }
  }
  return (
    <div className={columns?.imageLink ?`${styles.image_container} coloum-${countOfPortraitTile} header-tile`:`${styles.col}`}>
      {columns?.imageLink ? (
        <PortraitTile props={columns} navigationTitle={navigationTitle} />
      ) : (
        <>
          <p className={`x-small-md x-small-sm small-xs bold ${styles.col_heading}`}>
            {columns?.columnTitle}
          </p>
          <ul>
            {columns?.columnItems?.map((columnItem, index) => {
              return (
                <li key={index}>
                  <a
                    id={`submenu-${handleize(columnItem.subTitle)}-${makeId(3)}`}
                    className={`x-small-md x-small-sm small-xs ga-4-global`}
                    data-ga4={"Navigation link: " + columnItem.subTitle}
                    href={
                      columnItem.subTitleLink ? columnItem.subTitleLink : "#"
                    }
                    aria-label={columnItem.subTitle}
                    onClick={(e) => handleClick(e,columnItem.subTitleLink)}
                    tabIndex={0}
                  >
                    {columnItem.subTitle}
                  </a>
                </li>
              );
            })}
          </ul>
        </>
      )}
    </div>
  );
}
export default SubMenuColumn;
